import { Dispatch } from '@reduxjs/toolkit';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { CaseQueryResult } from 'dashboard/models/case-query-result';
import { setCaseQueryResults } from 'dashboard/redux/slices/case';
import { DashboardThunkAction } from 'dashboard/redux/types';

export function refreshCaseQueryResult(
  caseId: string,
  caseQueryResult: CaseQueryResult,
): DashboardThunkAction {
  return async (dispatch: Dispatch) => {
    const caseQueryResultsResponse =
      await SessionClientDashboard.postResourceAction<CaseQueryResult>(
        { id: caseQueryResult.id, type: caseQueryResult.type },
        'refresh',
      );

    dispatch(
      setCaseQueryResults({ key: caseId, caseQueryResults: [caseQueryResultsResponse.data] }),
    );
  };
}
